/**
 * Chování vlastních tb-* sekcí.
 *
 * Dřív byl každý kus jako inline <script> v Liquidu své sekce. To znamenalo, že
 * se posílal v HTML při každém načtení stránky, necachoval se a nešel debugovat.
 * Navíc byl drag-scroll zkopírovaný ve třech sekcích slovo od slova.
 *
 * Načítá se globálně z theme.liquid s defer. Každá část si sama ověří, že její
 * prvky na stránce vůbec jsou, takže na stránkách bez dané sekce nic nedělá.
 *
 * Init je idempotentní přes data-tb-init na prvku, protože Theme Editor sekci
 * překresluje a shopify:section:load spouští init znovu.
 */
(function () {
  'use strict';

  /* Zámek scrollu stránky pro modály tb-* sekcí. Bez padding-right: místo pro
   scrollbar drží html { scrollbar-gutter: stable } v base.css, takže stránka
   při zmizení scrollbaru neposkočí. Dřívější kompenzace paddingem by ji teď
   naopak posunula o šířku scrollbaru doleva. */
  function lockPageScroll() {
    document.body.style.overflow = 'hidden';
  }

  function unlockPageScroll() {
    document.body.style.overflow = '';
  }

  /* ────────────────────────────────────────────────────────────────────
     Sdílený drag-scroll pro vodorovné karuselové mřížky.
     Používají ho tb-feature-cards, tb-accessory-compat a tb-related-products.
     ──────────────────────────────────────────────────────────────────── */
  var DRAG_TARGETS = [
    { selector: '.tb-feature-cards-grid', mobileOnly: false },
    { selector: '.tb-accessory-compat-grid', mobileOnly: true },
    { selector: '.tb-related-grid', mobileOnly: true },
  ];

  function initDragScroll(el) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var hasMoved = false;
    var pointerId = null;

    el.addEventListener('pointerdown', function (e) {
      /* Jen primární tlačítko, pravý klik ignorovat. */
      if (e.button && e.button !== 0) return;
      isDown = true;
      hasMoved = false;
      startX = e.clientX;
      scrollLeft = el.scrollLeft;
      pointerId = e.pointerId;
      try {
        el.setPointerCapture(e.pointerId);
      } catch (_) {}
      /* Snap během tahu vypnout, jinak to cuká. */
      el.style.scrollSnapType = 'none';
    });

    el.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var walk = e.clientX - startX;
      if (Math.abs(walk) > 4) hasMoved = true;
      el.scrollLeft = scrollLeft - walk;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      /* Snap zpět, dojede na nejbližší kartu. */
      el.style.scrollSnapType = '';
      if (pointerId != null) {
        try {
          el.releasePointerCapture(pointerId);
        } catch (_) {}
        pointerId = null;
      }
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', endDrag);

    /* Po tahu nesmí dojít ke kliknutí na kartu pod kurzorem. */
    el.addEventListener(
      'click',
      function (e) {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
          hasMoved = false;
        }
      },
      true
    );
  }

  function initDragScrollAll(scope) {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    DRAG_TARGETS.forEach(function (target) {
      if (target.mobileOnly && !isMobile) return;
      scope.querySelectorAll(target.selector).forEach(function (el) {
        if (el.dataset.tbDragInit === '1') return;
        el.dataset.tbDragInit = '1';
        initDragScroll(el);
      });
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     tb-product-tabs — přepínání tabů
     ──────────────────────────────────────────────────────────────────── */
  function initTabs(scope) {
    scope.querySelectorAll('.tb-product-tabs').forEach(function (root) {
      if (root.dataset.tbTabsInit === '1') return;
      root.dataset.tbTabsInit = '1';

      var buttons = root.querySelectorAll('[data-tb-tab]');
      var panels = root.querySelectorAll('[data-tb-panel]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var target = btn.getAttribute('data-tb-tab');
          buttons.forEach(function (b) {
            var isActive = b.getAttribute('data-tb-tab') === target;
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-tb-panel') === target);
          });
        });
      });
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     tb-size-chart-popup — modal s tabulkou velikostí a přepínačem cm/in
     ──────────────────────────────────────────────────────────────────── */
  var SIZE_CHART_BTN_BASE =
    'appearance:none;border-radius:999px;padding:8px 22px;font-family:inherit;font-size:13px;font-weight:500;letter-spacing:0.02em;text-transform:uppercase;cursor:pointer;line-height:1;min-width:64px;';
  var SIZE_CHART_ACTIVE = SIZE_CHART_BTN_BASE + 'background:#252525;color:#FFFCF5;border:1px solid #252525;';
  var SIZE_CHART_IDLE =
    SIZE_CHART_BTN_BASE + 'background:transparent;color:#252525;border:1px solid rgba(37,37,37,0.25);';

  function initSizeChart() {
    var modal = document.querySelector('[data-tb-size-chart-modal]');
    if (!modal) return;

    /* Po překreslení sekce v Theme Editoru je v dokumentu nový modal a starý
       pod <body>. querySelector vrací ten dřívější v dokumentu, tedy nový. */
    document.querySelectorAll('[data-tb-size-chart-modal]').forEach(function (el) {
      if (el !== modal) el.remove();
    });

    if (modal.dataset.tbInit === '1') return;
    modal.dataset.tbInit = '1';

    /* Přesun pod body, ať modal neuvízne v cizím stacking kontextu. */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    function setUnit(unit) {
      modal.classList.remove('is-unit-cm', 'is-unit-in');
      modal.classList.add('is-unit-' + unit);
      var btns = modal.querySelectorAll('[data-tb-size-chart-unit]');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var isActive = b.getAttribute('data-tb-size-chart-unit') === unit;
        b.setAttribute('aria-pressed', String(isActive));
        b.style.cssText = isActive ? SIZE_CHART_ACTIVE : SIZE_CHART_IDLE;
      }
      var cells = modal.querySelectorAll('.tb-size-chart-val');
      for (var j = 0; j < cells.length; j++) {
        var el = cells[j];
        var isCm = el.classList.contains('tb-size-chart-val--cm');
        el.style.display = (unit === 'cm' && isCm) || (unit === 'in' && !isCm) ? 'inline' : 'none';
      }
    }

    function openModal() {
      lockPageScroll();
      modal.hidden = false;
      var closeBtn = modal.querySelector('.tb-size-chart-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      unlockPageScroll();
    }

    /* Delegace na document — trigger je v hero i v tabech a může přijít později. */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-tb-size-chart-trigger]');
      if (trigger) {
        e.preventDefault();
        openModal();
        return;
      }
      var unitBtn = e.target.closest('[data-tb-size-chart-unit]');
      if (unitBtn && modal.contains(unitBtn)) {
        setUnit(unitBtn.getAttribute('data-tb-size-chart-unit'));
        return;
      }
      if (!modal.hidden) {
        if (
          e.target.closest('[data-tb-size-chart-close]') ||
          (modal.contains(e.target) && !e.target.closest('.tb-size-chart-modal__panel'))
        ) {
          closeModal();
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    setUnit('cm');
  }

  /* ────────────────────────────────────────────────────────────────────
     tb-results-slider — countup procent, progress bar, swipe
     ──────────────────────────────────────────────────────────────────── */
  function initResultsSlider() {
    var root = document.querySelector('[data-tb-results-slider]');
    if (!root || root.dataset.tbInit === '1') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tb-slides] .tb-results-slider__slide'));
    if (!slides.length) return;
    root.dataset.tbInit = '1';

    var percentEl = root.querySelector('[data-tb-percent]');
    var barEl = root.querySelector('[data-tb-progress-bar]');
    var progressTextEl = root.querySelector('[data-tb-progress-text]');
    var footnoteEl = root.querySelector('[data-tb-footnote]');
    var counterEl = root.querySelector('[data-tb-counter]');
    var prevBtn = root.querySelector('[data-tb-prev]');
    var nextBtn = root.querySelector('[data-tb-next]');

    var ANIM_MS = 1400;
    var current = 0;
    var raf = null;
    var currentNum = 0; // aktuálně zobrazená % hodnota textu

    function unesc(s) {
      var t = document.createElement('textarea');
      t.innerHTML = s || '';
      return t.value;
    }

    /* Bar fill: CSS transition na width. Nastavujeme inline style i --fill,
       ať se to chytne bez ohledu na to, kterou verzi CSS má prohlížeč v cache. */
    function setBarFill(pct) {
      if (!barEl) return;
      barEl.style.width = pct + '%';
      barEl.style.setProperty('--fill', pct + '%');
    }

    /* Countup čísla přes RAF, CSS počítadlový primitiv nemá. */
    function animateNumberTo(target, dur) {
      if (raf) cancelAnimationFrame(raf);
      dur = dur || ANIM_MS;
      var start = currentNum;
      if (start === target) {
        percentEl.textContent = target + '%';
        currentNum = target;
        return;
      }
      var t0 = performance.now();
      function step(now) {
        var t = Math.min(1, (now - t0) / dur);
        var eased = 1 - Math.pow(1 - t, 3);
        var v = Math.round(start + (target - start) * eased);
        percentEl.textContent = v + '%';
        currentNum = v;
        if (t < 1) raf = requestAnimationFrame(step);
        else raf = null;
      }
      raf = requestAnimationFrame(step);
    }

    function render(i, opts) {
      opts = opts || {};
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === i);
        s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
      });
      var slide = slides[i];
      var pct = Math.max(0, Math.min(100, parseInt(slide.dataset.percent, 10) || 0));
      progressTextEl.innerHTML = unesc(slide.dataset.progressText);
      footnoteEl.innerHTML = unesc(slide.dataset.footnote);
      counterEl.textContent = i + 1 + '/' + slides.length;

      if (opts.instant) {
        percentEl.textContent = pct + '%';
        currentNum = pct;
        /* Nejdřív commitnout 0 %, teprve pak animovat na cíl. */
        setBarFill(0);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            setBarFill(pct);
          });
        });
      } else {
        setBarFill(pct);
        animateNumberTo(pct);
      }
    }

    function goPrev() {
      current = (current - 1 + slides.length) % slides.length;
      render(current);
    }
    function goNext() {
      current = (current + 1) % slides.length;
      render(current);
    }
    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    /* Swipe na obrázku: doleva další, doprava předchozí, práh 40 px vodorovně. */
    var swipeArea = root.querySelector('.tb-results-slider__right');
    if (swipeArea) {
      var startX = 0;
      var startY = 0;
      var tracking = false;
      swipeArea.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches.length) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );
      swipeArea.addEventListener(
        'touchend',
        function (e) {
          if (!tracking) return;
          tracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) goNext();
            else goPrev();
          }
        },
        { passive: true }
      );

      /* Bonus pro desktop: tažení myší. */
      var mouseDown = false;
      var mouseStartX = 0;
      swipeArea.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        mouseDown = true;
        mouseStartX = e.clientX;
      });
      swipeArea.addEventListener('pointerup', function (e) {
        if (!mouseDown) return;
        mouseDown = false;
        var dx = e.clientX - mouseStartX;
        if (Math.abs(dx) > 40) {
          if (dx < 0) goNext();
          else goPrev();
        }
      });
    }

    /* Text i bar startují na nule, animace se spustí až je sekce ve viewportu. */
    percentEl.textContent = '0%';
    currentNum = 0;
    setBarFill(0);
    progressTextEl.innerHTML = unesc(slides[0].dataset.progressText);
    footnoteEl.innerHTML = unesc(slides[0].dataset.footnote);
    counterEl.textContent = '1/' + slides.length;

    var triggered = false;
    function fire() {
      if (triggered) return;
      triggered = true;
      var pct = parseInt(slides[0].dataset.percent, 10) || 0;
      setBarFill(pct);
      animateNumberTo(pct);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              fire();
              obs.disconnect();
            }
          });
        },
        { threshold: 0.25 }
      );
      io.observe(root);
      /* Pojistka, kdyby IO nefiroval (sekce už ve viewportu při pomalém initu). */
      setTimeout(fire, 1500);
    } else {
      fire();
    }
  }

  /* ────────────────────────────────────────────────────────────────────
     Before/after posuvník (v tb-results-slider)
     ──────────────────────────────────────────────────────────────────── */
  function initBeforeAfter(scope) {
    scope.querySelectorAll('[data-tb-ba]').forEach(function (root) {
      if (root.dataset.tbInit === '1') return;
      var range = root.querySelector('[data-tb-ba-range]') || root.querySelector('.tb-ba-slider__range');
      var before = root.querySelector('[data-tb-ba-before]');
      var handle = root.querySelector('[data-tb-ba-handle]');
      if (!range || !before || !handle) return;
      root.dataset.tbInit = '1';

      var update = function () {
        var p = range.value;
        before.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        handle.style.left = p + '%';
      };
      range.addEventListener('input', update);
      update();
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     tb-data-request-form — postupné odkrývání polí po výběru země
     ──────────────────────────────────────────────────────────────────── */
  function initDataRequestForm() {
    var form = document.getElementById('DataRequestForm');
    if (!form || form.dataset.tbInit === '1') return;

    var country = form.querySelector('#DrfCountry');
    var gated = form.querySelectorAll('.tb-drf__gated');
    if (!country || !gated.length) return;
    form.dataset.tbInit = '1';

    function sync() {
      var open = country.value !== '';
      gated.forEach(function (el) {
        el.hidden = !open;
        /* `required` se musí přepínat spolu s viditelností, jinak prohlížeč
           odmítne odeslat formulář kvůli povinnému skrytému poli a uživateli
           u toho nic nenapíše. Radia povinná jsou, checkboxy ne. */
        el.querySelectorAll('input[type="radio"]').forEach(function (i) {
          i.required = open;
        });
      });
    }

    /* „Aspoň jeden zaškrtnutý" HTML nativně neumí a hlídat to přes submit +
       preventDefault tady nefunguje: submit se spustí a defaultPrevented je
       true, ale stránka se stejně odešle, protože formulář dosubmitne
       programově injektovaný skript. Proto se blokuje samo tlačítko. */
    var submitBtn = form.querySelector('button[type="submit"]');
    var note = document.getElementById('DrfTypeNote');

    function syncSubmit() {
      if (!submitBtn) return;
      var gateOpen = country.value !== '';
      var anyType = form.querySelectorAll('.tb-drf__chips input[type="checkbox"]:checked').length > 0;
      var blocked = gateOpen && !anyType;
      submitBtn.disabled = blocked;
      submitBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      if (note) note.hidden = !blocked;
    }

    country.addEventListener('change', function () {
      sync();
      syncSubmit();
    });
    form.addEventListener('change', syncSubmit);
    sync();
    syncSubmit();
  }

  /* ────────────────────────────────────────────────────────────────────
     Omnibus tooltip s nejnižší cenou za 30 dní (tb-product-hero)
     ──────────────────────────────────────────────────────────────────── */
  var priceInfoBound = false;
  /* Otevřený tooltip posune vodorovně tak, aby zůstal 16 px od okrajů viewportu
     (--tb-tip-shift, šipka se posune opačně a míří dál na ikonu). Zavřený tooltip
     je display:none, šířku 0 přeskočí. */
  function placePriceTip(wrap) {
    var tip = wrap.querySelector('.tb-price-info__tooltip');
    if (!tip) return;
    tip.style.setProperty('--tb-tip-shift', '0px');
    var r = tip.getBoundingClientRect();
    if (!r.width) return;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var gap = 16;
    var shift = 0;
    if (r.left < gap) shift = gap - r.left;
    else if (r.right > vw - gap) shift = vw - gap - r.right;
    if (shift) tip.style.setProperty('--tb-tip-shift', Math.round(shift) + 'px');
  }
  function initPriceInfo(scope) {
    var wraps = scope.querySelectorAll('[data-tb-price-info]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      if (wrap.dataset.tbInit === '1') return;
      wrap.dataset.tbInit = '1';
      var btn = wrap.querySelector('[data-tb-price-info-btn]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        placePriceTip(wrap);
      });
      /* Desktop: tooltip se otevírá i přes :hover. */
      wrap.addEventListener('mouseenter', function () {
        placePriceTip(wrap);
      });
    });

    if (priceInfoBound) return;
    priceInfoBound = true;
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-tb-price-info]').forEach(function (wrap) {
        if (!wrap.contains(e.target)) {
          var btn = wrap.querySelector('[data-tb-price-info-btn]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-tb-price-info]').forEach(placePriceTip);
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     Cena v hero po změně varianty (tb-product-hero, id="price-<section>")

     Dawn product-info.js při změně varianty přepíše innerHTML obalu
     #price-<section> ze server-renderu (cena, přeškrtnutá cena, Omnibus
     tooltip, „Vyprodáno“). Nový (i) button je bez listeneru, proto se po
     každé výměně znovu zavolá initPriceInfo. Ta je idempotentní přes
     data-tb-init na [data-tb-price-info], takže vícenásobné volání nevadí.

     Odběr variantChange se zakládá jen jednou za život stránky (flag na
     <html> přes data-tb-init-price-sync), i když initAll běží znovu po
     shopify:section:load.
     ──────────────────────────────────────────────────────────────────── */
  function initPriceVariantSync() {
    var html = document.documentElement;
    if (html.dataset.tbInitPriceSync === '1') return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    html.dataset.tbInitPriceSync = '1';

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.sectionId) return;
      var wrap = document.getElementById('price-' + event.data.sectionId);
      /* product-info.js mění innerHTML synchronně před publish(), ale pro
         jistotu (a pro případné budoucí view transitions) ještě po snímku. */
      initPriceInfo(wrap || document);
      window.requestAnimationFrame(function () {
        initPriceInfo(wrap || document);
      });
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     Dostupnost a doprava pod CTA (snippets/tb-delivery-info.liquid)

     Hlavní práci dělá Dawn product-info.js: obal #Inventory-{sectionId}
     přepíše ze server-renderu (tam je i pravidlo záporného skladu).
     Tady jen pojistky:
       - variantChange s variant.available === false → vždy Vyprodáno
         a bez řádku expedice (kdyby swap selhal),
       - neexistující kombinace (setUnavailable nic nepublikuje, jen
         vyprázdní input[name=id]) → řádek dostupnosti schovat.
     Odběry se zakládají jednou za život stránky (flag na <html>).
     ──────────────────────────────────────────────────────────────────── */
  function deliverySetSoldOut(box) {
    var stock = box.querySelector('[data-tb-delivery-stock]');
    var text = box.querySelector('[data-tb-delivery-stock-text]');
    var cutoff = box.querySelector('[data-tb-delivery-cutoff]');
    if (stock) {
      stock.classList.remove('tb-delivery__stock--in');
      stock.classList.add('tb-delivery__stock--out');
    }
    if (text && box.dataset.tOut) text.textContent = box.dataset.tOut;
    if (cutoff) cutoff.remove();
  }

  function initDeliveryInfo() {
    var html = document.documentElement;
    if (html.dataset.tbInitDelivery === '1') return;
    if (!document.querySelector('[data-tb-delivery]')) return;
    html.dataset.tbInitDelivery = '1';

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var d = event && event.data;
        if (!d || !d.sectionId) return;
        var box = document.querySelector('[data-tb-delivery][data-section-id="' + d.sectionId + '"]');
        if (!box) return;
        var wrap = box.querySelector('.tb-delivery__stock-wrap');
        if (wrap) wrap.hidden = false;
        if (d.variant && d.variant.available === false) deliverySetSoldOut(box);
      });
    }

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.name !== 'id' || input.value) return;
      var form = input.form || (input.closest && input.closest('form'));
      var section = form && form.closest('[data-section]');
      var sid = section && section.getAttribute('data-section');
      if (!sid) return;
      var box = document.querySelector('[data-tb-delivery][data-section-id="' + sid + '"]');
      var wrap = box && box.querySelector('.tb-delivery__stock-wrap');
      if (wrap) wrap.hidden = true;
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     Karta produktu: ikonové tlačítko v rohu obrázku (snippets/tb-card-action.liquid).
     Karta je celá <a> na produkt, tlačítko dovnitř vnořit nejde, proto span
     [data-tb-card-action]:
       add  = /cart/add.js s variantou z data-variant-id, pak otevře cart drawer
              stejně jako product-form.js (renderContents + cartUpdate event)
       link = přesměruje na data-href (PDP produktu s víc variantami)
     Bez JS klik probublá na kartu a vede na PDP.
     Delegace na document, jednou za život stránky.
     ──────────────────────────────────────────────────────────────────── */
  function initCardAction() {
    var html = document.documentElement;
    if (html.dataset.tbInitCardAction === '1') return;
    html.dataset.tbInitCardAction = '1';

    function go(href, newTab) {
      if (newTab) window.open(href, '_blank');
      else window.location.href = href;
    }

    function addToCart(el) {
      var href = el.getAttribute('data-href');
      var variantId = el.getAttribute('data-variant-id');
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      if (!variantId) return go(href);

      el.classList.add('is-loading');
      el.setAttribute('aria-busy', 'true');

      var body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      if (cart && cart.getSectionsToRender) {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(el);
      }

      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          /* Chyba (např. vyprodáno mezitím): PDP ukáže stav i hlídání. */
          if (res.status) return go(href);
          if (!cart || !cart.renderContents) {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tb-card-action', productVariantId: variantId, cartData: res });
          }
          var inner = cart.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        })
        .catch(function () { go(href); })
        .finally(function () {
          el.classList.remove('is-loading');
          el.removeAttribute('aria-busy');
        });
    }

    function activate(el, e) {
      var href = el.getAttribute('data-href');
      if (!href) return;
      e.preventDefault();
      e.stopPropagation();
      if (el.getAttribute('data-tb-card-action') === 'add') addToCart(el);
      else go(href, e.metaKey || e.ctrlKey);
    }

    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-tb-card-action]');
      if (el) activate(el, e);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var el = e.target.closest && e.target.closest('[data-tb-card-action]');
      if (el) activate(el, e);
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     Sticky add-to-cart lišta (snippets/tb-sticky-atc.liquid)

     Nemá vlastní formulář, tlačítko proklikne skutečné hero CTA. Dva
     paralelní product formuláře na jedné PDP by se při změně varianty
     rozešly, protože hidden input name=id aktualizuje product-info jen
     ve své sekci.
     ──────────────────────────────────────────────────────────────────── */
  function initStickyAtc() {
    var bar = document.querySelector('[data-tb-sticky-atc]');
    if (!bar) return;

    /* Fixed pozice se rozbije uvnitř předka s transformem, a Theme Editor sekci
       překresluje. Lišta proto žije přímo pod <body> a starší kus se zahodí. */
    document.querySelectorAll('[data-tb-sticky-atc]').forEach(function (el) {
      if (el !== bar) el.remove();
    });
    if (bar.dataset.tbInit === '1') return;
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    var sectionId = bar.dataset.sectionId;
    var heroBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!heroBtn) {
      bar.remove();
      return;
    }
    bar.dataset.tbInit = '1';

    var visible = false;
    var cta = bar.querySelector('[data-tb-sticky-cta]');
    var ctaText = bar.querySelector('[data-tb-sticky-cta-text]');
    var priceEl = bar.querySelector('[data-tb-sticky-price]');
    var variantEl = bar.querySelector('[data-tb-sticky-variant]');

    /* Hlídat dostupnost (initRestock): u vyprodané varianty je hlavní CTA
       trigger v hero, ne disabled „Vyprodáno“. Hledá se při každém použití,
       protože product-info může trigger vyměnit. */
    function restockTrigger() {
      var list = document.querySelectorAll('[data-tb-restock-trigger]');
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-section-id') === sectionId) return list[i];
      }
      return null;
    }

    cta.addEventListener('click', function () {
      var rt = restockTrigger();
      if (rt && !rt.hidden) {
        rt.click();
        return;
      }
      heroBtn.click();
    });

    /* Stav se zrcadlí z hero tlačítka. MutationObserver chytí i cestu
       setUnavailable() v product-info.js, která žádnou událost nepublikuje. */
    function syncCta() {
      /* Vyprodáno: sticky CTA je aktivní „Hlídat dostupnost“. Rozhoduje
         viditelnost triggeru, ne disabled hero tlačítka (Dawn ho při každé
         změně varianty dočasně disabluje). */
      var rt = restockTrigger();
      if (rt && !rt.hidden) {
        cta.disabled = false;
        var rl = rt.querySelector('[data-tb-restock-label]');
        if (rl) ctaText.textContent = rl.textContent.trim();
        return;
      }
      cta.disabled = heroBtn.hasAttribute('disabled');
      var label = heroBtn.querySelector('span');
      if (label) ctaText.textContent = label.textContent.trim();
    }
    function syncCtaAndH() {
      syncCta();
      if (visible) syncH();
    }
    syncCta();
    new MutationObserver(syncCtaAndH).observe(heroBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    /* Cena a varianta z překreslené hero sekce, žádné počítání ceny v JS. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== sectionId) return;
        var newPrice = event.data.html.querySelector('.tb-product-hero__price-amount');
        if (newPrice && priceEl) priceEl.textContent = newPrice.textContent.trim();
        if (variantEl && event.data.variant) variantEl.textContent = event.data.variant.title;
        syncCtaAndH();
      });
    }

    /* Přepnutí vyprodáno / skladem z initRestock. Pořadí pub/sub subscriberů
       není zaručené, proto vlastní událost až po změně triggeru. */
    document.addEventListener('tb:restock:change', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;
      if (!document.body.contains(bar)) return;
      syncCtaAndH();
    });

    /* Výška lišty jako CSS proměnná na <body>: AI chat (tk-chat.css, --tk-chat-offset)
       posune launcher i panel nad lištu, aby nepřekrýval CTA. Obnovuje se i při
       změně popisku (zalomení) a resize, ne jen při změně viditelnosti. */
    function syncH() {
      try {
        document.body.style.setProperty('--tk-sticky-buy-h', visible ? bar.offsetHeight + 'px' : '0px');
      } catch (e) {}
    }
    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      bar.classList.toggle('tb-sticky-atc--visible', next);
      bar.setAttribute('aria-hidden', String(!next));
      syncH();
    }
    var watchEl = heroBtn.closest('.tb-product-hero__qty-and-cta') || heroBtn;

    /* Záloha k IntersectionObserveru: ten hlásí jen změnu protnutí. Když je CTA
       při načtení pod viewportem a stránka jedním skokem (kotva, scrollTo,
       obnovení pozice) odroluje až nad něj, stav „neprotíná“ se nezmění
       a observer mlčí. Přepočet z getBoundingClientRect, max. 1× za snímek. */
    var rafPending = false;
    function checkPosition() {
      rafPending = false;
      if (!document.body.contains(bar)) return;
      var r = watchEl.getBoundingClientRect();
      /* Stejná podmínka jako v observeru: celé CTA nad viewportem. */
      setVisible(r.height > 0 && r.bottom < 0);
    }
    function scheduleCheck() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(checkPosition);
    }
    window.addEventListener('scroll', scheduleCheck, { passive: true });

    window.addEventListener('resize', function () {
      if (!document.body.contains(bar)) return;
      if (visible) syncH();
      scheduleCheck();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            /* Jen když CTA vyrolovalo NAD viewport, ne když je teprve pod ním. */
            setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      ).observe(watchEl);
    }
    checkPosition();
  }

  /* ────────────────────────────────────────────────────────────────────
     Hlídat dostupnost (snippets/tb-restock.liquid, assets/tb-restock.css)

     Port MO snippets/tk-rez-modal.liquid + blocks/add-to-cart.liquid, bez
     karetní delegace a bez „Prodej skončil". Přihlášení jde na hub:
       POST <endpoint>             { shop, email, variant_id, product_handle,
                                     product_title, variant_title, locale,
                                     country, hp_check (honeypot), challenge }
       GET  <endpoint>/challenge   → { ok:true, token }
     Odpovědi: 200 ok · 409 code=in_stock · 403 code=challenge (1× retry
     s novým tokenem) · 400/429/5xx s lokalizovaným `error` ze serveru.

     Stav vyprodáno řídí PUB_SUB_EVENTS.variantChange (event.data.variant
     .available), NE disabled atribut hero CTA: Dawn ho při každé změně
     varianty dočasně disabluje (resetProductFormState) a trigger by
     problikával. Cesta setUnavailable() nic nepublikuje, jen nastaví
     input[name=id] na prázdnou hodnotu a dispatchne change, proto se
     poslouchá i ten.

     Okno není <form>: na therabody.cz injektovaný skript odešle formulář
     i po preventDefault. Odesílá tlačítko type=button a Enter v inputu.

     Sticky lišta (initStickyAtc) se o změně dozví přes událost
     tb:restock:change na document.
     ──────────────────────────────────────────────────────────────────── */
  var RESTOCK_CH_TTL = 60 * 60 * 1000; /* server drží token 2 h, obnovit po hodině (jako PQ a contact) */
  var RESTOCK_CH_MIN_WAIT = 2600; /* server bere token nejdřív 2 s po vydání */
  var RESTOCK_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var restockCh = { token: null, at: 0, pending: null, url: '' };
  var restockModal = null;
  var restockCfg = null;
  var restockCtx = null;
  var restockLastFocus = null;
  var restockCloseTimer = null;
  var restockScrollLocked = false;
  var restockBound = false;
  var restockHashDone = false;

  function restockFetchChallenge() {
    if (!restockCh.url) return Promise.resolve(null);
    restockCh.pending = fetch(restockCh.url, {
      method: 'GET',
      credentials: 'omit',
      headers: { accept: 'application/json' },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        if (j && j.token) {
          restockCh.token = j.token;
          restockCh.at = Date.now();
        }
        return restockCh.token;
      })
      .catch(function () {
        return null;
      })
      .then(function (t) {
        restockCh.pending = null;
        return t;
      });
    return restockCh.pending;
  }

  /* Vyzvedne token jen když žádný není nebo vypršel. */
  function restockPrefetch() {
    if (restockCh.pending) return;
    if (!restockCh.token || Date.now() - restockCh.at > RESTOCK_CH_TTL) restockFetchChallenge();
  }

  /* Vrátí platný token a zaručí, že od jeho vydání uplynulo aspoň 2,6 s. */
  function restockEnsureChallenge() {
    var p;
    if (restockCh.pending) p = restockCh.pending;
    else if (!restockCh.token || Date.now() - restockCh.at > RESTOCK_CH_TTL) p = restockFetchChallenge();
    else p = Promise.resolve(restockCh.token);
    return p.then(function (t) {
      var since = Date.now() - restockCh.at;
      if (t && since < RESTOCK_CH_MIN_WAIT) {
        return new Promise(function (res) {
          setTimeout(function () {
            res(t);
          }, RESTOCK_CH_MIN_WAIT - since);
        });
      }
      return t;
    });
  }

  function restockTriggerFor(sectionId) {
    var list = document.querySelectorAll('[data-tb-restock-trigger]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-section-id') === String(sectionId)) return list[i];
    }
    return null;
  }

  /* Jeden zdroj pravdy pro trigger, třídu wrapperu, badge u ceny a sticky lištu. */
  function restockApplyState(sectionId, soldOut, variant) {
    var trigger = restockTriggerFor(sectionId);
    if (trigger) {
      trigger.hidden = !soldOut;
      if (variant && variant.id) {
        trigger.setAttribute('data-variant-id', String(variant.id));
        if (trigger.hasAttribute('data-variant-title')) {
          trigger.setAttribute('data-variant-title', variant.title || '');
        }
      }
      var wrap = trigger.closest('.tb-product-hero__qty-and-cta');
      if (wrap) wrap.classList.toggle('is-tb-restock', soldOut);
    }

    /* Badge „Vyprodáno" u ceny. Hero ho dřív při změně varianty neměnil. */
    var hero = document.getElementById('ProductHero-' + sectionId);
    if (hero) {
      var badge = hero.querySelector('.tb-product-hero__price-badge');
      if (badge) {
        badge.hidden = !soldOut;
      } else if (soldOut) {
        var priceWrap = hero.querySelector('.tb-product-hero__price-wrap');
        if (priceWrap) {
          badge = document.createElement('span');
          badge.className = 'tb-product-hero__price-badge';
          badge.textContent = (window.variantStrings && window.variantStrings.soldOut) || '';
          priceWrap.appendChild(badge);
        }
      }
    }

    if (soldOut) restockPrefetch();

    try {
      document.dispatchEvent(
        new CustomEvent('tb:restock:change', { detail: { sectionId: String(sectionId), soldOut: soldOut } })
      );
    } catch (_) {}
  }

  function restockEls() {
    var m = restockModal;
    return {
      stepForm: m.querySelector('[data-tb-restock-step="form"]'),
      stepSuccess: m.querySelector('[data-tb-restock-step="success"]'),
      product: m.querySelector('[data-tb-restock-product]'),
      email: m.querySelector('[data-tb-restock-email]'),
      hp: m.querySelector('[data-tb-restock-hp]'),
      error: m.querySelector('[data-tb-restock-error]'),
      submit: m.querySelector('[data-tb-restock-submit]'),
      submitLabel: m.querySelector('[data-tb-restock-submit-label]'),
      successTitle: m.querySelector('[data-tb-restock-success-title]'),
      successText: m.querySelector('[data-tb-restock-success-text]'),
      buy: m.querySelector('[data-tb-restock-buy]'),
      panel: m.querySelector('.tb-restock__panel'),
    };
  }

  function restockShowError(msg) {
    var el = restockEls();
    if (el.error) {
      el.error.textContent = msg;
      el.error.hidden = false;
    }
    if (el.email) el.email.setAttribute('aria-invalid', 'true');
  }

  function restockClearError() {
    if (!restockModal) return;
    var el = restockEls();
    if (el.error) {
      el.error.hidden = true;
      el.error.textContent = '';
    }
    if (el.email) el.email.removeAttribute('aria-invalid');
  }

  function restockResetSubmit() {
    if (!restockModal) return;
    var el = restockEls();
    if (el.submit) el.submit.disabled = false;
    if (el.submitLabel) el.submitLabel.textContent = restockCfg.t.submit || '';
  }

  function restockShowStep(success) {
    var el = restockEls();
    if (el.stepForm) el.stepForm.hidden = !!success;
    if (el.stepSuccess) el.stepSuccess.hidden = !success;
    /* Fokus na tlačítko nového kroku, jinak by zůstal na skrytém prvku. */
    if (success) {
      var target =
        el.buy && !el.buy.hidden ? el.buy : el.stepSuccess && el.stepSuccess.querySelector('[data-tb-restock-close]');
      if (target) {
        try {
          target.focus({ preventScroll: true });
        } catch (_) {}
      }
    }
  }

  function restockShowSuccess() {
    var el = restockEls();
    if (el.successTitle) el.successTitle.textContent = restockCfg.t.success_heading || '';
    if (el.successText) el.successText.textContent = restockCfg.t.success_body || '';
    if (el.buy) el.buy.hidden = true;
    restockShowStep(true);
  }

  function restockShowInStock(ctx, serverMsg) {
    var el = restockEls();
    if (el.successTitle) el.successTitle.textContent = restockCfg.t.in_stock_heading || '';
    if (el.successText) el.successText.textContent = serverMsg || restockCfg.t.in_stock_body || '';
    if (el.buy) {
      if (ctx && ctx.productUrl) {
        el.buy.href = ctx.productUrl + (ctx.variantId ? '?variant=' + encodeURIComponent(ctx.variantId) : '');
        el.buy.hidden = false;
      } else {
        el.buy.hidden = true;
      }
    }
    restockShowStep(true);
  }

  function restockLockScroll() {
    if (restockScrollLocked) return;
    restockScrollLocked = true;
    lockPageScroll();
  }

  function restockUnlockScroll() {
    if (!restockScrollLocked) return;
    restockScrollLocked = false;
    unlockPageScroll();
  }

  function restockOpen(trigger) {
    if (!restockModal || !trigger) return;
    var sectionId = trigger.getAttribute('data-section-id');

    /* Aktuální varianta z formuláře hero sekce přebíjí hodnotu z renderu. */
    var variantId = trigger.getAttribute('data-variant-id') || '';
    var form = document.getElementById('product-form-' + sectionId);
    var input = form && form.querySelector('input[name="id"]');
    if (input) {
      if (!input.value) return; /* neexistující kombinace, není co hlídat */
      variantId = input.value;
    }
    if (!variantId) return;

    var variantTitle = '';
    if (trigger.getAttribute('data-variant-id') === String(variantId)) {
      variantTitle = trigger.getAttribute('data-variant-title') || '';
    }

    restockCtx = {
      variantId: String(variantId),
      variantTitle: variantTitle,
      productTitle: trigger.getAttribute('data-product-title') || '',
      productHandle: trigger.getAttribute('data-product-handle') || '',
      productUrl: trigger.getAttribute('data-product-url') || '',
    };

    if (restockCloseTimer) {
      clearTimeout(restockCloseTimer);
      restockCloseTimer = null;
    }

    var el = restockEls();
    restockShowStep(false);
    restockClearError();
    restockResetSubmit();
    if (el.email) el.email.value = '';
    if (el.hp) el.hp.value = '';
    if (el.product) {
      var label = restockCtx.productTitle + (restockCtx.variantTitle ? ' · ' + restockCtx.variantTitle : '');
      el.product.textContent = label;
      el.product.hidden = !label;
    }

    restockPrefetch();

    restockLastFocus = document.activeElement;
    restockModal.hidden = false;
    restockModal.setAttribute('aria-hidden', 'false');
    restockLockScroll();

    var fineInput = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!restockModal) return;
        restockModal.classList.add('is-open');
        /* Na desktopu rovnou do pole, na mobilu panel (klávesnice by vyjela
           uprostřed animace a posunula okno). */
        var target = fineInput && el.email ? el.email : el.panel;
        if (target) {
          try {
            target.focus({ preventScroll: true });
          } catch (_) {}
        }
      });
    });
  }

  function restockClose() {
    if (!restockModal || restockModal.hidden) return;
    var modal = restockModal;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    restockUnlockScroll();
    if (restockCloseTimer) clearTimeout(restockCloseTimer);
    restockCloseTimer = setTimeout(function () {
      restockCloseTimer = null;
      modal.hidden = true;
      var back = restockLastFocus;
      restockLastFocus = null;
      if (back && back.focus && document.contains(back)) {
        try {
          back.focus({ preventScroll: true });
        } catch (_) {}
      }
    }, 240);
  }

  function restockLocale() {
    var l = (restockCfg && restockCfg.locale) || document.documentElement.getAttribute('lang') || 'cs';
    l = String(l).slice(0, 2).toLowerCase();
    return l === 'en' || l === 'sk' ? l : 'cs';
  }

  /* Jedno odeslání na hub. isRetry brání nekonečné smyčce u challenge retry. */
  function restockSubmit(ctx, email, isRetry) {
    return restockEnsureChallenge()
      .then(function (token) {
        var el = restockEls();
        var payload = {
          shop: restockCfg.shop,
          email: email,
          variant_id: parseInt(ctx.variantId, 10),
          locale: restockLocale(),
          hp_check: (el.hp && el.hp.value) || '',
          challenge: token || '',
        };
        if (restockCfg.country) payload.country = restockCfg.country;
        if (ctx.productHandle) payload.product_handle = ctx.productHandle;
        if (ctx.productTitle) payload.product_title = ctx.productTitle;
        if (ctx.variantTitle) payload.variant_title = ctx.variantTitle;

        return fetch(restockCfg.endpoint, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'content-type': 'application/json', accept: 'application/json' },
          body: JSON.stringify(payload),
        }).then(function (r) {
          return r
            .json()
            .catch(function () {
              return {};
            })
            .then(function (b) {
              return { status: r.status, body: b || {} };
            });
        });
      })
      .then(function (res) {
        /* Mezitím zavřeno a otevřeno pro jinou variantu: výsledek zahodit. */
        if (ctx !== restockCtx || !restockModal) return;
        var s = res.status;
        var b = res.body || {};

        if (s === 200 && b.ok !== false) {
          restockShowSuccess();
          return;
        }
        if (s === 409 && b.code === 'in_stock') {
          restockShowInStock(ctx, b.error);
          return;
        }
        /* Neplatný nebo prošlý anti-spam token: nový token a jeden retry. */
        if (s === 403 && b.code === 'challenge' && !isRetry) {
          restockCh.token = null;
          restockCh.at = 0;
          return restockFetchChallenge().then(function () {
            return restockSubmit(ctx, email, true);
          });
        }
        var t = restockCfg.t;
        var msg = b.error || (s === 429 ? t.rate_limit : s >= 500 ? t.server_error : t.error);
        restockResetSubmit();
        restockShowError(msg || '');
      })
      .catch(function () {
        if (ctx !== restockCtx || !restockModal) return;
        restockResetSubmit();
        restockShowError(restockCfg.t.error || '');
      });
  }

  function restockHandleSubmit() {
    if (!restockModal || !restockCtx) return;
    var el = restockEls();
    if (el.submit && el.submit.disabled) return;
    var email = ((el.email && el.email.value) || '').trim();
    if (!RESTOCK_EMAIL_RE.test(email)) {
      restockShowError(restockCfg.t.invalid || '');
      if (el.email) {
        try {
          el.email.focus();
        } catch (_) {}
      }
      return;
    }
    if (!restockCfg.endpoint) {
      restockShowError(restockCfg.t.error || '');
      return;
    }
    restockClearError();
    if (el.submit) el.submit.disabled = true;
    if (el.submitLabel) el.submitLabel.textContent = restockCfg.t.sending || '';
    restockSubmit(restockCtx, email, false);
  }

  function restockFocusables() {
    if (!restockModal) return [];
    var nodes = restockModal.querySelectorAll(
      '.tb-restock__panel button:not([disabled]), .tb-restock__panel a[href], .tb-restock__panel input:not([disabled]):not([tabindex="-1"])'
    );
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getClientRects().length && !nodes[i].closest('[hidden]')) out.push(nodes[i]);
    }
    return out;
  }

  function restockBindModal(modal) {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-tb-restock-close]')) {
        e.preventDefault();
        restockClose();
        return;
      }
      if (e.target.closest('[data-tb-restock-submit]')) {
        e.preventDefault();
        restockHandleSubmit();
      }
    });

    var email = modal.querySelector('[data-tb-restock-email]');
    if (email) {
      email.addEventListener('input', restockClearError);
      email.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          restockHandleSubmit();
        }
      });
    }
  }

  function initRestock() {
    var modal = document.querySelector('[data-tb-restock-modal]');
    var triggers = document.querySelectorAll('[data-tb-restock-trigger]');
    if (!modal && !triggers.length) return;

    if (modal) {
      /* Po překreslení sekce v Theme Editoru je v dokumentu nový modal
         (v sekci) a starý pod <body>. querySelector vrací ten nový. */
      document.querySelectorAll('[data-tb-restock-modal]').forEach(function (el) {
        if (el !== modal) el.remove();
      });

      if (modal.dataset.tbInit !== '1') {
        modal.dataset.tbInit = '1';
        /* Portal pod <body>: mimo stacking kontexty sekce a password manageři
           (Bitwarden inline menu) se chovají normálně. */
        if (modal.parentElement !== document.body) document.body.appendChild(modal);

        var t = {};
        var i18n = modal.querySelector('[data-tb-restock-i18n]');
        if (i18n) {
          try {
            t = JSON.parse(i18n.textContent) || {};
          } catch (_) {}
        }
        var country = String(modal.getAttribute('data-country') || '').trim().toUpperCase();
        restockCfg = {
          endpoint: modal.getAttribute('data-endpoint') || '',
          shop: modal.getAttribute('data-shop') || '',
          country: /^[A-Z]{2}$/.test(country) ? country : '',
          locale: modal.getAttribute('data-locale') || '',
          t: t,
        };
        restockCh.url = restockCfg.endpoint ? restockCfg.endpoint + '/challenge' : '';
        /* Starý modal mohl být otevřený (překreslení sekce v editoru). */
        restockUnlockScroll();
        if (restockCloseTimer) {
          clearTimeout(restockCloseTimer);
          restockCloseTimer = null;
        }
        restockCtx = null;
        restockModal = modal;
        restockBindModal(modal);
      }
    }

    /* Wrapper třída a prefetch podle stavu z Liquidu (hidden na triggeru). */
    var anySoldOut = false;
    triggers.forEach(function (trigger) {
      var soldOut = !trigger.hidden;
      if (soldOut) anySoldOut = true;
      var wrap = trigger.closest('.tb-product-hero__qty-and-cta');
      if (wrap) wrap.classList.toggle('is-tb-restock', soldOut);
    });
    if (anySoldOut && restockModal) restockPrefetch();

    if (!restockBound) {
      restockBound = true;

      /* Delegace na document: trigger může přijít později (výměna produktu
         v product-info, překreslení sekce). */
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest && e.target.closest('[data-tb-restock-trigger]');
        if (!trigger) return;
        e.preventDefault();
        restockOpen(trigger);
      });

      /* Esc + focus trap. */
      document.addEventListener('keydown', function (e) {
        if (!restockModal || restockModal.hidden) return;
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          restockClose();
          return;
        }
        if (e.key !== 'Tab') return;
        var items = restockFocusables();
        if (!items.length) {
          e.preventDefault();
          return;
        }
        var first = items[0];
        var last = items[items.length - 1];
        var active = document.activeElement;
        if (!restockModal.contains(active)) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && (active === first || items.indexOf(active) === -1)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }, true);

      /* Stav vyprodáno podle vybrané varianty. */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var d = event && event.data;
          if (!d || !d.sectionId || !d.variant) return;
          if (!restockTriggerFor(d.sectionId)) return;
          restockApplyState(d.sectionId, d.variant.available === false, d.variant);
        });
      }

      /* setUnavailable() (neexistující kombinace) nic nepublikuje, jen vyprázdní
         input[name=id] a dispatchne change. Trigger i badge pak schovat. */
      document.addEventListener('change', function (e) {
        var input = e.target;
        if (!input || input.name !== 'id' || input.value) return;
        var form = input.form || (input.closest && input.closest('form'));
        var trigger = form && form.querySelector('[data-tb-restock-trigger]');
        if (!trigger) return;
        restockApplyState(trigger.getAttribute('data-section-id'), false, null);
      });
    }

    /* Auto-open z odkazu …#tb-notify (např. z karty produktu). */
    if (!restockHashDone && location.hash === '#tb-notify') {
      restockHashDone = true;
      setTimeout(function () {
        var list = document.querySelectorAll('[data-tb-restock-trigger]');
        var target = null;
        for (var i = 0; i < list.length; i++) {
          if (!list[i].hidden) {
            target = list[i];
            break;
          }
        }
        try {
          history.replaceState(null, '', location.pathname + location.search);
        } catch (_) {}
        if (!target) return;
        try {
          target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        } catch (_) {}
        restockOpen(target);
      }, 150);
    }
  }

  /* ────────────────────────────────────────────────────────────────────
     tb-product-question: dotaz k produktu přes hub (snippets/tb-product-question.liquid)

     Záměrně bez <form> a bez submit eventu: na therabody.cz injektovaný skript
     odešle formulář i po preventDefault (GET s osobními údaji v URL). Odesílá
     tlačítko type="button", Enter v inputech se obsluhuje přes keydown.

     Overlay se při initu přesune pod <body> (jinak uvízne ve stacking kontextu
     hero karty). Po překreslení sekce v Theme Editoru je v dokumentu nový
     overlay se stejným id a ten starý pod <body> se zahodí.

     Anti-spam challenge (hub GET <endpoint>/challenge): token se vyzvedne při
     otevření a posílá se VŽDY. Server ho bere nejdřív 2 s po vydání, platí 2 h.
     Na 403 s code=challenge jeden tichý retry s novým tokenem.
     ──────────────────────────────────────────────────────────────────── */
  var PQ_TOKEN_MAX_AGE = 3600000; // obnovit po hodině (server drží 2 h)
  var PQ_TOKEN_MIN_AGE = 2600; // server bere token nejdřív 2 s po vydání
  var PQ_FOCUSABLE =
    'a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var pqDelegationBound = false;

  function setupProductQuestion(root) {
    if (root.dataset.tbInit === '1') return root._tbPq || null;

    var overlay = root.querySelector('[data-tb-pq-overlay]');
    if (!overlay) return null;
    root.dataset.tbInit = '1';

    /* Starý overlay po překreslení sekce (stejné id, už pod <body>) pryč. */
    document.querySelectorAll('[data-tb-pq-overlay]').forEach(function (el) {
      if (el !== overlay && el.id === overlay.id) el.remove();
    });
    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

    var D = root.dataset;
    var endpoint = (D.endpoint || '').replace(/\/+$/, '');
    var dialog = overlay.querySelector('[data-tb-pq-dialog]');
    var formBox = overlay.querySelector('[data-tb-pq-form]');
    var result = overlay.querySelector('[data-tb-pq-result]');
    var errBox = overlay.querySelector('[data-tb-pq-error]');
    var submitBtn = overlay.querySelector('[data-tb-pq-submit]');
    var submitLabel = submitBtn ? submitBtn.textContent : '';
    var lastFocused = null;
    var sending = false;
    var chTok = null;
    var chAt = 0;
    var chPending = null;

    function field(name) {
      return formBox.querySelector('[name="' + name + '"]');
    }
    function val(name) {
      var el = field(name);
      return el ? String(el.value || '').trim() : '';
    }

    function fetchChallenge() {
      if (!endpoint) return Promise.resolve();
      if (chPending) return chPending;
      chPending = fetch(endpoint + '/challenge', { credentials: 'omit', cache: 'no-store' })
        .then(function (r) {
          return r.json();
        })
        .then(function (j) {
          if (j && j.token) {
            chTok = j.token;
            chAt = Date.now();
          }
        })
        .catch(function () {})
        .then(function () {
          chPending = null;
        });
      return chPending;
    }
    function tokenStale() {
      return !chTok || Date.now() - chAt > PQ_TOKEN_MAX_AGE;
    }
    function waitTokenAge() {
      var wait = chTok ? Math.max(0, PQ_TOKEN_MIN_AGE - (Date.now() - chAt)) : 0;
      return new Promise(function (r) {
        setTimeout(r, wait);
      });
    }

    function showError(msg) {
      if (!errBox) return;
      errBox.textContent = msg || D.errNetwork || '';
      errBox.hidden = false;
    }
    function clearError() {
      if (errBox) errBox.hidden = true;
    }

    /* Aktuální varianta z hero formuláře (product-info.js ji přepisuje při změně). */
    function productUrl() {
      var url = D.productUrl || '';
      if (D.hasVariants !== 'true') return url;
      var info = root.closest('product-info');
      var input = info && info.querySelector('input.product-variant-id, form[id^="product-form-"] input[name="id"]');
      var vid = input && input.value;
      if (!vid) return url;
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(vid);
    }

    function trapTab(e) {
      var list = Array.prototype.filter.call(dialog.querySelectorAll(PQ_FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (!dialog.contains(document.activeElement)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
        return;
      }
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        trapTab(e);
      }
    }

    function open() {
      lastFocused = document.activeElement;
      if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
      if (result) result.hidden = true;
      formBox.hidden = false;
      clearError();
      if (tokenStale()) fetchChallenge();
      lockPageScroll();
      overlay.hidden = false;
      /* Capture: Esc zavře jen tenhle dialog, chat ho díky defaultPrevented ignoruje. */
      document.addEventListener('keydown', onKeydown, true);
      /* Fokus na kartu, ne na pole: na mobilu by fokus pole otevřel klávesnici. */
      if (dialog && dialog.focus) dialog.focus();
    }

    function close() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      unlockPageScroll();
      document.removeEventListener('keydown', onKeydown, true);
      if (lastFocused && lastFocused.focus && document.contains(lastFocused)) lastFocused.focus();
    }

    function showSuccess() {
      formBox.hidden = true;
      var msg = field('message');
      var consent = field('consent');
      if (msg) msg.value = '';
      if (consent) consent.checked = false;
      if (result) {
        result.hidden = false;
        result.focus();
      }
    }

    function submit() {
      if (sending) return;
      clearError();

      var name = val('name');
      var email = val('email');
      var message = val('message');
      var consentEl = field('consent');
      if (!name) return showError(D.errName);
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return showError(D.errEmail);
      if (!message) return showError(D.errMessage);
      if (!consentEl || !consentEl.checked) return showError(D.errConsent);
      if (!endpoint) return showError(D.errNetwork);

      var payload = {
        shop: D.shop || '',
        name: name,
        email: email,
        message: message,
        consent: true,
        locale: D.locale || 'cs',
        product_handle: D.productHandle || '',
        product_title: D.productTitle || '',
        product_url: productUrl(),
        /* Honeypot (v DOM tb_hp_ref): vyplněné pole hub uloží jako spam, podání se neztratí. */
        hp_check: val('tb_hp_ref'),
        challenge: '',
      };

      sending = true;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = D.sending || submitLabel;

      function post() {
        payload.challenge = chTok || '';
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          body: JSON.stringify(payload),
        }).then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              return { ok: res.ok, status: res.status, data: data || {} };
            });
        });
      }

      (tokenStale() ? fetchChallenge() : chPending || Promise.resolve())
        .then(waitTokenAge)
        .then(post)
        .then(function (r) {
          if (!r.ok && r.status === 403 && r.data.code === 'challenge') {
            chTok = null;
            return fetchChallenge().then(waitTokenAge).then(post);
          }
          return r;
        })
        .then(function (r) {
          if (r.ok && r.data.ok) showSuccess();
          else showError(r.data.error || D.errNetwork);
        })
        .catch(function () {
          showError(D.errNetwork);
        })
        .then(function () {
          sending = false;
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          submitBtn.textContent = submitLabel;
        });
    }

    if (submitBtn) submitBtn.addEventListener('click', submit);

    /* Enter v jednořádkových polích odešle (textarea dělá nový řádek). */
    formBox.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;
      e.preventDefault();
      submit();
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('[data-tb-pq-close]')) close();
    });

    root._tbPq = { open: open, close: close };
    return root._tbPq;
  }

  function initProductQuestion(scope) {
    (scope || document).querySelectorAll('[data-tb-pq]').forEach(setupProductQuestion);

    /* Otevírání přes delegaci: funguje i pro trigger, který přibyl bez
       shopify:section:load (např. výměna product-info při combined listings). */
    if (pqDelegationBound) return;
    pqDelegationBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-tb-pq-open]');
      if (!btn) return;
      var root = btn.closest('[data-tb-pq]');
      var ctrl = root && setupProductQuestion(root);
      if (!ctrl) return;
      e.preventDefault();
      ctrl.open();
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     Kontaktní formulář napojený na hub (sections/tb-contact-form.liquid)

     Sekce nemá <form> a tlačítko je type="button". Na therabody.cz
     injektovaný skript dosubmitne formulář i po preventDefault (GET
     s osobními údaji v URL), takže se odesílá jen click handlerem
     a Enter v inputu se obsluhuje ručně.

     Kontrakt hubu (shopify-hub src/modules/messages/routes.js):
       GET  {endpoint}/challenge → { ok, token }, token platí až 2 s po
            vydání a nejvýš 2 h, proto čekání 2,6 s a obnova po hodině
       POST {endpoint} JSON { shop, name, email, message, consent: true,
            locale, hp_check: '' (honeypot), challenge }
       200 { ok: true } | 4xx/5xx { ok: false, error } s lokalizovanou větou
       403 { code: 'challenge' } → nový token a jeden retry
     ──────────────────────────────────────────────────────────────────── */
  var CONTACT_TOKEN_MIN_AGE = 2600;
  var CONTACT_TOKEN_MAX_AGE = 3600000;
  var CONTACT_EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function initContactForm(scope) {
    (scope || document).querySelectorAll('[data-tb-contact-form]').forEach(function (root) {
      if (root.dataset.tbInit === '1') return;

      var I = root.dataset;
      var endpoint = (I.endpoint || '').trim().replace(/\/+$/, '');
      var step = root.querySelector('[data-tb-contact-step="form"]');
      var done = root.querySelector('[data-tb-contact-step="done"]');
      var btn = root.querySelector('[data-tb-contact-submit]');
      var btnLabel = root.querySelector('[data-tb-contact-submit-label]') || btn;
      var errBox = root.querySelector('[data-tb-contact-error]');
      var againBtn = root.querySelector('[data-tb-contact-again]');
      if (!endpoint || !step || !done || !btn || !errBox) return;
      root.dataset.tbInit = '1';

      var originalLabel = btnLabel.textContent;
      var sending = false;

      function field(name) {
        return root.querySelector('[name="' + name + '"]');
      }
      function val(name) {
        var el = field(name);
        return el ? String(el.value || '').trim() : '';
      }

      /* Token se bere hned při načtení, při ručním vyplňování je pak
         dávno starší než 2 s a na nic se nečeká. */
      var chTok = null;
      var chAt = 0;
      var chPending = null;
      function fetchChallenge() {
        if (chPending) return chPending;
        chPending = fetch(endpoint + '/challenge', { credentials: 'omit', cache: 'no-store' })
          .then(function (r) {
            return r.json();
          })
          .then(function (j) {
            if (j && j.token) {
              chTok = j.token;
              chAt = Date.now();
            }
          })
          .catch(function () {})
          .then(function () {
            chPending = null;
          });
        return chPending;
      }
      function waitForTokenAge() {
        var wait = chTok ? Math.max(0, CONTACT_TOKEN_MIN_AGE - (Date.now() - chAt)) : 0;
        return new Promise(function (resolve) {
          setTimeout(resolve, wait);
        });
      }
      fetchChallenge();

      function clearError() {
        errBox.hidden = true;
        errBox.textContent = '';
        root.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
          el.removeAttribute('aria-invalid');
        });
      }
      function showError(msg, fieldName) {
        errBox.textContent = msg || I.errGeneric || '';
        errBox.hidden = false;
        var el = fieldName ? field(fieldName) : null;
        if (el) {
          el.setAttribute('aria-invalid', 'true');
          el.focus();
        }
      }

      function validate() {
        if (!val('name')) return { msg: I.errName, field: 'name' };
        var email = val('email');
        if (!email || !CONTACT_EMAIL_RE.test(email)) return { msg: I.errEmail, field: 'email' };
        if (!val('message')) return { msg: I.errMessage, field: 'message' };
        var consent = field('consent');
        if (!consent || !consent.checked) return { msg: I.errConsent, field: 'consent' };
        return null;
      }

      function resetFields() {
        ['name', 'email', 'message', 'tb_hp_ref'].forEach(function (n) {
          var el = field(n);
          if (el) el.value = '';
        });
        var consent = field('consent');
        if (consent) consent.checked = false;
      }

      function showDone() {
        step.hidden = true;
        done.hidden = false;
        try {
          done.focus({ preventScroll: true });
        } catch (_) {
          done.focus();
        }
        done.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      function setBusy(busy) {
        sending = busy;
        btn.disabled = busy;
        btn.setAttribute('aria-busy', busy ? 'true' : 'false');
        btnLabel.textContent = busy ? I.submitting || originalLabel : originalLabel;
      }

      function post(payload) {
        payload.challenge = chTok || '';
        return fetch(endpoint, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }).then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              return { ok: res.ok, status: res.status, data: data || {} };
            });
        });
      }

      function submit() {
        if (sending) return;
        clearError();

        var err = validate();
        if (err) {
          showError(err.msg, err.field);
          return;
        }

        var payload = {
          shop: I.shop || '',
          name: val('name'),
          email: val('email'),
          message: val('message'),
          consent: true,
          locale: I.locale || 'cs',
          /* Honeypot (v DOM tb_hp_ref): vyplněné pole hub uloží jako spam, podání se neztratí. */
          hp_check: val('tb_hp_ref'),
        };

        setBusy(true);
        var prep = !chTok || Date.now() - chAt > CONTACT_TOKEN_MAX_AGE ? fetchChallenge() : Promise.resolve();
        prep
          .then(waitForTokenAge)
          .then(function () {
            return post(payload);
          })
          .then(function (r) {
            /* Expirovaný token nebo změna IP: jeden tichý retry s novým. */
            if (r.status === 403 && r.data.code === 'challenge') {
              chTok = null;
              return fetchChallenge()
                .then(waitForTokenAge)
                .then(function () {
                  return post(payload);
                });
            }
            return r;
          })
          .then(function (r) {
            if (r.ok && r.data.ok) {
              resetFields();
              showDone();
            } else {
              showError(r.data.error || I.errGeneric);
            }
          })
          .catch(function () {
            showError(I.errNetwork || I.errGeneric);
          })
          .then(function () {
            setBusy(false);
          });
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        submit();
      });

      /* Enter v jednořádkovém poli nebo na checkboxu odešle, v textarea
         dělá nový řádek. */
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || e.isComposing) return;
        var t = e.target;
        if (!t || t.tagName !== 'INPUT') return;
        e.preventDefault();
        submit();
      });

      if (againBtn) {
        againBtn.addEventListener('click', function () {
          clearError();
          done.hidden = true;
          step.hidden = false;
          var first = field('name');
          if (first) first.focus();
        });
      }
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     tb-withdrawal: odstoupení od smlouvy (Shopify Hub, modul withdrawals)

     Dvoukrokový flow: vyplnění → rekapitulace s vědomým potvrzením → úspěch.
     Žádný <form> a žádný submit event: na therabody.cz injektovaný skript
     odešle formulář i po preventDefault (GET s osobními údaji v URL).
     Tlačítka jsou type="button", Enter v inputu obsluhujeme ručně.

     Odpovědi hubu (kontrakt withdrawalContract v shopify-hub):
       200 {ok:true}           → obrazovka úspěchu
       4xx {ok:false,error}    → error je lokalizovaná věta, zobrazit
       502 {ok:false,error}    → podání JE uložené, jen neodešlo potvrzení,
                                 říct to a nabídnout opakování
       jinak / výpadek sítě    → obecná hláška s e-mailem eshopu
     Withdrawal endpoint challenge nemá, token se neposílá.
     ──────────────────────────────────────────────────────────────────── */
  function initWithdrawal(scope) {
    scope.querySelectorAll('[data-tb-withdrawal]').forEach(function (root) {
      if (root.dataset.tbInit === '1') return;
      var card = root.querySelector('[data-tb-wd-card]');
      var step1 = root.querySelector('[data-tb-wd-step="1"]');
      var step2 = root.querySelector('[data-tb-wd-step="2"]');
      var done = root.querySelector('[data-tb-wd-step="done"]');
      var continueBtn = root.querySelector('[data-tb-wd-action="continue"]');
      var backBtn = root.querySelector('[data-tb-wd-action="back"]');
      var submitBtn = root.querySelector('[data-tb-wd-action="submit"]');
      var summary = root.querySelector('[data-tb-wd-summary]');
      if (!card || !step1 || !step2 || !done || !continueBtn || !backBtn || !submitBtn || !summary) return;
      root.dataset.tbInit = '1';

      var I = root.dataset;
      var steps = root.querySelector('[data-tb-wd-steps]');
      var recapTitle = root.querySelector('[data-tb-wd-recap-title]');
      var submitText = root.querySelector('[data-tb-wd-submit-text]');
      var notice = step2.querySelector('[data-tb-wd-notice]');
      var sending = false;
      var LOCALES = { cs: 1, sk: 1, en: 1 };

      function field(name) {
        return card.querySelector('[name="' + name + '"]');
      }
      function val(name) {
        var el = field(name);
        return el ? String(el.value || '').trim() : '';
      }
      /* Posílá se, co zákazník napsal. Jen úvodní "#" pryč, kontrakt ho nechce
         (server ho stejně odstraní, prefix Therabody nemá). */
      function orderValue() {
        return val('order_number').replace(/^#+\s*/, '');
      }

      function showMsg(scopeEl, selector, msg) {
        var box = scopeEl.querySelector(selector);
        if (!box) return;
        box.textContent = msg;
        box.hidden = false;
      }
      function hideMsgs(scopeEl) {
        scopeEl.querySelectorAll('[data-tb-wd-error], [data-tb-wd-notice]').forEach(function (box) {
          box.hidden = true;
          box.textContent = '';
        });
      }
      function markInvalid(names) {
        ['name', 'email', 'order_number'].forEach(function (n) {
          var el = field(n);
          if (!el) return;
          if (names.indexOf(n) !== -1) el.setAttribute('aria-invalid', 'true');
          else el.removeAttribute('aria-invalid');
        });
        if (names.length) {
          var first = field(names[0]);
          if (first) first.focus();
        }
      }

      function validate() {
        var missing = [];
        if (!val('name')) missing.push('name');
        if (!val('email')) missing.push('email');
        if (!orderValue()) missing.push('order_number');
        if (missing.length) {
          markInvalid(missing);
          return I.errRequired;
        }
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val('email'))) {
          markInvalid(['email']);
          return I.errEmail;
        }
        markInvalid([]);
        return null;
      }

      function buildSummary() {
        var rows = [
          [I.sumName, val('name')],
          [I.sumEmail, val('email')],
          [I.sumOrder, '#' + orderValue()],
          [I.sumItems, val('items') || I.empty],
          [I.sumReason, val('reason') || I.empty],
        ];
        summary.textContent = '';
        rows.forEach(function (r) {
          var row = document.createElement('div');
          row.className = 'tb-wd__summary-row';
          var dt = document.createElement('dt');
          dt.textContent = r[0];
          var dd = document.createElement('dd');
          dd.textContent = r[1];
          row.appendChild(dt);
          row.appendChild(dd);
          summary.appendChild(row);
        });
      }

      function scrollToCard() {
        var rect = card.getBoundingClientRect();
        if (rect.top >= 80 && rect.top <= window.innerHeight * 0.5) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var top = rect.top + (window.pageYOffset || document.documentElement.scrollTop) - 120;
        try {
          window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        } catch (_) {
          window.scrollTo(0, Math.max(0, top));
        }
      }

      function goStep(n) {
        step1.hidden = n !== 1;
        step2.hidden = n !== 2;
        done.hidden = n !== 'done';
        if (steps) {
          steps.hidden = n === 'done';
          steps.querySelectorAll('[data-tb-wd-progress]').forEach(function (li) {
            var p = parseInt(li.getAttribute('data-tb-wd-progress'), 10);
            li.classList.toggle('is-active', p === n);
            li.classList.toggle('is-done', n === 'done' || (typeof n === 'number' && p < n));
          });
        }
      }

      /* Hub podání přijme vždy (fail-open), odpověď ale říká, jestli objednávka sedí:
         {ok:true, verified:false, reason:'not_found'|'email_mismatch'|'not_checked'}.
         Upozornění jen u not_found a email_mismatch. Bez verified (starší hub,
         honeypot) nebo s jiným reason se ukáže jen běžný úspěch. */
      function showVerify(j) {
        var box = done.querySelector('[data-tb-wd-verify]');
        if (!box) return;
        var reason = j && j.verified === false ? j.reason : '';
        var msg = reason === 'not_found' ? I.verifyNotFound : reason === 'email_mismatch' ? I.verifyEmail : '';
        box.textContent = msg || '';
        box.hidden = !msg;
      }

      function setSubmitLabel(label) {
        if (submitText) submitText.textContent = label;
      }

      function doContinue() {
        hideMsgs(step1);
        var err = validate();
        if (err) {
          showMsg(step1, '[data-tb-wd-error]', err);
          return;
        }
        buildSummary();
        hideMsgs(step2);
        setSubmitLabel(I.submitLabel);
        goStep(2);
        scrollToCard();
        if (recapTitle) recapTitle.focus({ preventScroll: true });
      }

      function doSubmit() {
        if (sending) return;
        hideMsgs(step2);
        var wasRetry = notice && notice.dataset.tbWdSaved === '1';
        var body = {
          shop: I.shop,
          name: val('name'),
          email: val('email'),
          order_number: orderValue(),
          items: val('items').slice(0, 2000),
          reason: val('reason').slice(0, 2000),
          locale: LOCALES[I.locale] ? I.locale : 'cs',
          /* Honeypot, u člověka vždy prázdný. V DOM tb_hp_ref (name="company" vyplňuje autofill). */
          hp_check: field('tb_hp_ref') ? field('tb_hp_ref').value : '',
        };
        if (!I.endpoint) {
          showMsg(step2, '[data-tb-wd-error]', I.errGeneric);
          return;
        }

        sending = true;
        submitBtn.disabled = true;
        backBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
        setSubmitLabel(I.sendingLabel);

        var controller = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = controller
          ? setTimeout(function () {
              controller.abort();
            }, 60000)
          : null;

        fetch(I.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          body: JSON.stringify(body),
          signal: controller ? controller.signal : undefined,
        })
          .then(function (r) {
            return r
              .json()
              .catch(function () {
                return {};
              })
              .then(function (j) {
                return { status: r.status, j: j || {} };
              });
          })
          .then(function (res) {
            if (res.status >= 200 && res.status < 300 && res.j.ok) {
              if (notice) notice.dataset.tbWdSaved = '';
              showVerify(res.j);
              goStep('done');
              scrollToCard();
              done.focus({ preventScroll: true });
              return;
            }
            if (res.status === 502) {
              /* Podání je uložené, jen neodešel potvrzovací e-mail. */
              if (notice) notice.dataset.tbWdSaved = '1';
              showMsg(step2, '[data-tb-wd-notice]', I.saved);
              setSubmitLabel(I.resubmitLabel);
              return;
            }
            if (res.status >= 400 && res.status < 500 && res.j.error) {
              showMsg(step2, '[data-tb-wd-error]', String(res.j.error));
            } else {
              showMsg(step2, '[data-tb-wd-error]', I.errGeneric);
            }
            setSubmitLabel(wasRetry ? I.resubmitLabel : I.submitLabel);
          })
          .catch(function (err) {
            /* Timeout: hub mohl podání mezitím uložit (ověření objednávky a e-mail běží
               synchronně). Opakování by založilo duplicitní podání, proto upozornění. */
            if (err && err.name === 'AbortError' && I.timeout) {
              if (notice) notice.dataset.tbWdSaved = '1';
              showMsg(step2, '[data-tb-wd-notice]', I.timeout);
              setSubmitLabel(I.resubmitLabel);
              return;
            }
            showMsg(step2, '[data-tb-wd-error]', I.errGeneric);
            setSubmitLabel(wasRetry ? I.resubmitLabel : I.submitLabel);
          })
          .then(function () {
            if (timer) clearTimeout(timer);
            sending = false;
            submitBtn.disabled = false;
            backBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          });
      }

      continueBtn.addEventListener('click', doContinue);
      submitBtn.addEventListener('click', doSubmit);
      backBtn.addEventListener('click', function () {
        if (sending) return;
        hideMsgs(step2);
        if (notice) notice.dataset.tbWdSaved = '';
        setSubmitLabel(I.submitLabel);
        goStep(1);
        scrollToCard();
        var first = field('name');
        if (first) first.focus({ preventScroll: true });
      });

      /* Enter v jednořádkovém poli = Pokračovat. Bez <form> by nedělal nic,
         a submit event záměrně nepoužíváme. Textarea Enter nechává na nový řádek. */
      step1.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || e.isComposing) return;
        var t = e.target;
        if (!t || t.tagName !== 'INPUT' || t.name === 'tb_hp_ref') return;
        e.preventDefault();
        doContinue();
      });

      /* Opravené pole ztrácí červený rámeček hned při psaní. */
      step1.addEventListener('input', function (e) {
        if (e.target && e.target.getAttribute('aria-invalid') === 'true') {
          e.target.removeAttribute('aria-invalid');
        }
      });
    });
  }

  /* ────────────────────────────────────────────────────────────────────
     tb-instagram: příspěvky z hubu (feed.json), mřížka + modal s karuselem alb.

     Feed vydává hub (modul instagram), token Instagramu v theme není. Kontrakt:
     200 { ok, data: [ { id, caption, media_type, media_url, thumbnail_url,
     image_small, image_large, permalink, like_count, comments_count,
     children: { data: [...] } } ] }. Cokoli jiného než 200 s neprázdným data
     = sekce se TIŠE skryje (celý .shopify-section obal), důvod jde do konzole.

     Modal je div přesunutý pod <body>. Po překreslení sekce v Theme Editoru
     zůstane starý modal pod body, proto ho init i section:unload uklízí.
     Klávesy (Esc, šipky, Tab trap) obsluhuje jeden globální listener.
     ──────────────────────────────────────────────────────────────────── */
  var IG_ICON_SVG =
    '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" aria-hidden="true" focusable="false"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.2" fill="#fff" stroke="none"/></svg>';
  var IG_BADGE_VIDEO =
    '<svg viewBox="0 0 24 24" fill="#fff" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5z"/></svg>';
  var IG_BADGE_ALBUM =
    '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" aria-hidden="true" focusable="false"><rect x="8" y="8" width="13" height="13" rx="2"/><path d="M16 4H5a2 2 0 0 0-2 2v11"/></svg>';
  var IG_HEART_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1.1L12 21l7.8-7.5 1-1.1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
  var IG_COMMENT_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M21 11.5a8.4 8.4 0 0 1-12.2 7.5L3 21l2-5.8A8.4 8.4 0 1 1 21 11.5z"/></svg>';
  var IG_CHEVRON_PREV =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><polyline points="15 18 9 12 15 6"/></svg>';
  var IG_CHEVRON_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><polyline points="9 18 15 12 9 6"/></svg>';
  var IG_FEED_TIMEOUT_MS = 10000;

  /* Právě otevřený modal (controller), pro globální klávesy. */
  var igActive = null;
  var igGlobalBound = false;

  function igEsc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Do src/href pustit jen https adresy (feed je cizí vstup). */
  function igUrl(value) {
    var u = String(value == null ? '' : value).trim();
    return /^https:\/\//i.test(u) ? u : '';
  }

  /* Popisek: NEJDŘÍV escapovat, pak z @zmínek udělat odkazy (MO to dělalo naopak). */
  function igCaption(text) {
    if (!text) return '';
    return igEsc(text).replace(
      /(^|[^\w@])@([A-Za-z0-9_](?:[A-Za-z0-9_.]*[A-Za-z0-9_])?)/g,
      function (m, pre, user) {
        return (
          pre +
          '<a href="https://www.instagram.com/' + user + '/" target="_blank" rel="noopener noreferrer">@' + user + '</a>'
        );
      }
    );
  }

  function igNum(n) {
    if (n == null || !isFinite(n)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'cs', {
        notation: 'compact',
        maximumFractionDigits: 1,
      }).format(n);
    } catch (e) {
      return String(n);
    }
  }

  /* Obrázek dlaždice: image_small, jinak u videa thumbnail_url, jinak media_url
     (u alba první položka). Když chybí všechno, příspěvek se přeskočí. */
  function igTileSrc(post) {
    if (igUrl(post.image_small)) return igUrl(post.image_small);
    if (post.media_type === 'VIDEO') return igUrl(post.thumbnail_url);
    if (post.media_type === 'CAROUSEL_ALBUM') {
      var kid = post.children && post.children.data && post.children.data[0];
      if (kid) {
        var k =
          igUrl(kid.image_small) || igUrl(kid.media_type === 'VIDEO' ? kid.thumbnail_url : kid.media_url);
        if (k) return k;
      }
    }
    return igUrl(post.media_url);
  }

  /* Obrázek do modalu: image_large se stejným fallbackem. */
  function igLargeSrc(item) {
    return (
      igUrl(item.image_large) ||
      igUrl(item.media_type === 'VIDEO' ? item.thumbnail_url : item.media_url) ||
      igUrl(item.image_small)
    );
  }

  function igReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function igVisible(node) {
    return node.getClientRects().length > 0;
  }

  function igFocusables(modal) {
    var nodes = modal.querySelectorAll(
      'a[href], button:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(nodes, igVisible);
  }

  function igBindGlobal() {
    if (igGlobalBound) return;
    igGlobalBound = true;

    document.addEventListener('keydown', function (e) {
      if (!igActive) return;
      /* Šipky ve videu s ovládáním posouvají čas, tam je nechat. */
      var inVideo = e.target && e.target.tagName === 'VIDEO';
      if (e.key === 'Escape') {
        e.preventDefault();
        igActive.close();
      } else if (e.key === 'ArrowLeft' && !inVideo) {
        igActive.step(-1);
      } else if (e.key === 'ArrowRight' && !inVideo) {
        igActive.step(1);
      } else if (e.key === 'Tab') {
        var f = igFocusables(igActive.modal);
        if (!f.length) {
          e.preventDefault();
          return;
        }
        var first = f[0];
        var last = f[f.length - 1];
        var cur = document.activeElement;
        var inside = igActive.modal.contains(cur);
        if (e.shiftKey && (cur === first || !inside)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && (cur === last || !inside)) {
          e.preventDefault();
          first.focus();
        }
      }
    }, true);

    /* Smazaná / překreslovaná sekce v Theme Editoru: modal pod body uklidit. */
    document.addEventListener('shopify:section:unload', function (event) {
      var sid = event.detail && event.detail.sectionId;
      if (!sid) return;
      var modals = document.querySelectorAll('[data-tb-ig-modal]');
      for (var i = 0; i < modals.length; i++) {
        if (modals[i].getAttribute('data-tb-ig-modal') !== sid) continue;
        if (igActive && igActive.modal === modals[i]) igActive.close(true);
        modals[i].remove();
      }
    });
  }

  function igSetup(el) {
    if (el.dataset.tbInit === '1') return;
    el.dataset.tbInit = '1';

    var sid = el.getAttribute('data-section-id') || '';
    var grid = el.querySelector('[data-tb-ig-grid]');
    var status = el.querySelector('[data-tb-ig-status]');
    var modal = el.querySelector('[data-tb-ig-modal]');
    var feedUrl = igUrl(el.getAttribute('data-feed-url'));
    var postCount = parseInt(el.getAttribute('data-post-count'), 10) || 9;
    var layout = el.getAttribute('data-layout') || 'featured';
    var profileUrl = igUrl(el.getAttribute('data-profile-url'));
    var L = {
      slide: el.getAttribute('data-label-slide') || '',
      prevSlide: el.getAttribute('data-label-prev-slide') || '',
      nextSlide: el.getAttribute('data-label-next-slide') || '',
      likes: el.getAttribute('data-label-likes') || '',
      comments: el.getAttribute('data-label-comments') || '',
    };
    var host = el.closest('.shopify-section') || el;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    /* Starý modal téže sekce (pod body z minulého renderu) pryč, nový pod body. */
    var old = document.querySelectorAll('[data-tb-ig-modal]');
    for (var i = 0; i < old.length; i++) {
      if (old[i] !== modal && old[i].getAttribute('data-tb-ig-modal') === sid) {
        if (igActive && igActive.modal === old[i]) igActive.close(true);
        old[i].remove();
      }
    }
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);

    function hide(reason) {
      if (window.console) console.warn('[tb-instagram] sekce skrytá:', reason);
      if (designMode && grid) {
        grid.removeAttribute('aria-busy');
        grid.innerHTML =
          '<p class="tb-instagram__editor-note">' +
          igEsc('Feed z Instagramu teď nejde načíst (' + reason + '). Na webu se sekce skryje, vidíte to jen v editoru.') +
          '</p>';
        return;
      }
      host.style.display = 'none';
      if (modal) modal.remove();
    }

    if (!grid || !feedUrl) {
      hide('chybí mřížka nebo adresa feedu');
      return;
    }

    var posts = [];
    var curPost = 0;
    var curSlides = [];
    var curSlide = 0;
    var slideToken = 0;
    var lastFocus = null;
    var clearTimer = null;
    var mediaBox = modal && modal.querySelector('[data-tb-ig-media]');
    var captionEl = modal && modal.querySelector('[data-tb-ig-caption]');
    var statsEl = modal && modal.querySelector('[data-tb-ig-stats]');
    var ctaEl = modal && modal.querySelector('[data-tb-ig-cta]');
    var prevBtn = modal && modal.querySelector('[data-tb-ig-prev]');
    var nextBtn = modal && modal.querySelector('[data-tb-ig-next]');

    /* ── Mřížka ── */
    function render() {
      var reduced = igReducedMotion();
      grid.innerHTML = posts
        .map(function (p, idx) {
          var src = igTileSrc(p);
          var isVideo = p.media_type === 'VIDEO';
          var isAlbum = p.media_type === 'CAROUSEL_ALBUM';
          var alt = p.caption ? String(p.caption).replace(/\s+/g, ' ').trim().slice(0, 100) : 'Instagram';
          var href = igUrl(p.permalink) || profileUrl || 'https://www.instagram.com/';
          var cls = 'tb-instagram__item' + (layout === 'featured' && idx === 0 ? ' tb-instagram__item--large' : '');
          var videoSrc = isVideo && !reduced ? igUrl(p.media_url) : '';
          return (
            '<a class="' + cls + '" href="' + igEsc(href) + '" target="_blank" rel="noopener noreferrer" data-tb-ig-index="' + idx + '">' +
            '<img class="tb-instagram__img" src="' + igEsc(src) + '" alt="' + igEsc(alt) + '" loading="lazy" decoding="async" width="640" height="640">' +
            (videoSrc
              ? '<video class="tb-instagram__video" muted loop playsinline preload="none" disableremoteplayback aria-hidden="true" src="' + igEsc(videoSrc) + '"></video>'
              : '') +
            (isVideo ? '<span class="tb-instagram__badge">' + IG_BADGE_VIDEO + '</span>' : '') +
            (isAlbum ? '<span class="tb-instagram__badge">' + IG_BADGE_ALBUM + '</span>' : '') +
            '<span class="tb-instagram__overlay">' + IG_ICON_SVG + '</span>' +
            '</a>'
          );
        })
        .join('');
      grid.removeAttribute('aria-busy');
      if (status) status.textContent = '';

      /* Video se přehrává až ve viewportu. preload="none" bez autoplay = nestáhne se
         ani bajt, dokud se nezavolá play(). */
      var vids = grid.querySelectorAll('video.tb-instagram__video');
      if (vids.length && 'IntersectionObserver' in window) {
        var vObs = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) {
                var pr = en.target.play();
                if (pr && pr.catch) pr.catch(function () {});
              } else {
                en.target.pause();
              }
            });
          },
          { threshold: 0.3 }
        );
        Array.prototype.forEach.call(vids, function (v) {
          vObs.observe(v);
        });
      }

      /* Klik otevře modal. Ctrl/Cmd/Shift/prostřední tlačítko nechá odkaz na Instagram. */
      grid.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-tb-ig-index]');
        if (!tile || !modal || !mediaBox) return;
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        open(parseInt(tile.getAttribute('data-tb-ig-index'), 10), tile);
      });
    }

    /* ── Modal ── */
    function lockBox() {
      var w = mediaBox.offsetWidth;
      var h = mediaBox.offsetHeight;
      if (w > 40 && h > 40) {
        mediaBox.style.minWidth = w + 'px';
        mediaBox.style.minHeight = h + 'px';
      } else {
        mediaBox.style.minWidth = 'min(60vh, 70vw)';
        mediaBox.style.minHeight = 'min(60vh, 70vw)';
      }
    }

    function unlockBox() {
      mediaBox.style.minWidth = '';
      mediaBox.style.minHeight = '';
      mediaBox.classList.remove('is-loading');
      var l = mediaBox.querySelector('.tb-instagram-modal__loader');
      if (l) l.remove();
    }

    function showLoader() {
      mediaBox.classList.add('is-loading');
      if (!mediaBox.querySelector('.tb-instagram-modal__loader')) {
        var l = document.createElement('div');
        l.className = 'tb-instagram-modal__loader';
        mediaBox.appendChild(l);
      }
    }

    /* Obrázek se nejdřív předstáhne, box mezitím drží rozměr (žádný layout shift). */
    function showSlide(items, idx) {
      curSlides = items;
      curSlide = idx;
      var item = items[idx];
      var token = ++slideToken;
      var src = item.media_type === 'VIDEO' ? '' : igLargeSrc(item);
      if (src) {
        var pre = new Image();
        pre.src = src;
        if (pre.complete) {
          paintSlide(items, idx);
          return;
        }
        lockBox();
        showLoader();
        var done = function () {
          if (token === slideToken) paintSlide(items, idx);
        };
        pre.onload = done;
        pre.onerror = done;
        return;
      }
      paintSlide(items, idx);
    }

    function paintSlide(items, idx) {
      curSlides = items;
      curSlide = idx;
      var item = items[idx];
      var videoSrc = item.media_type === 'VIDEO' ? igUrl(item.media_url) : '';
      var html;
      if (videoSrc) {
        var poster = igLargeSrc(item);
        html =
          '<video src="' + igEsc(videoSrc) + '"' +
          (poster ? ' poster="' + igEsc(poster) + '"' : '') +
          ' controls loop playsinline muted' + (igReducedMotion() ? '' : ' autoplay') + '></video>';
      } else {
        html = '<img src="' + igEsc(igLargeSrc(item)) + '" alt="' + igEsc(L.slide + ' ' + (idx + 1)) + '">';
      }

      if (items.length > 1) {
        if (idx > 0) {
          html += '<button type="button" class="tb-instagram-modal__slide-nav tb-instagram-modal__slide-nav--prev" data-tb-ig-slide="' + (idx - 1) + '" aria-label="' + igEsc(L.prevSlide) + '">' + IG_CHEVRON_PREV + '</button>';
        }
        if (idx < items.length - 1) {
          html += '<button type="button" class="tb-instagram-modal__slide-nav tb-instagram-modal__slide-nav--next" data-tb-ig-slide="' + (idx + 1) + '" aria-label="' + igEsc(L.nextSlide) + '">' + IG_CHEVRON_NEXT + '</button>';
        }
        html +=
          '<div class="tb-instagram-modal__dots">' +
          items
            .map(function (_, i) {
              return (
                '<button type="button" class="tb-instagram-modal__dot' + (i === idx ? ' is-active' : '') + '" data-tb-ig-slide="' + i + '"' +
                ' aria-label="' + igEsc(L.slide + ' ' + (i + 1) + ' / ' + items.length) + '"' +
                (i === idx ? ' aria-current="true"' : '') + '></button>'
              );
            })
            .join('') +
          '</div>';
      }

      /* Fokus na šipce alba se po překreslení ztratí, vrátit ho na stejné místo. */
      var hadFocus = document.activeElement && mediaBox.contains(document.activeElement);
      mediaBox.innerHTML = html;
      unlockBox();
      if (hadFocus) {
        var again =
          mediaBox.querySelector('.tb-instagram-modal__dot.is-active') ||
          mediaBox.querySelector('[data-tb-ig-slide]');
        if (again) again.focus();
      }
    }

    function slideStep(dir) {
      var n = curSlide + dir;
      if (curSlides.length > 1 && n >= 0 && n < curSlides.length) {
        showSlide(curSlides, n);
        return true;
      }
      return false;
    }

    function postStep(dir) {
      var n = curPost + dir;
      if (n >= 0 && n < posts.length) {
        var v = mediaBox.querySelector('video');
        if (v) v.pause();
        fill(n);
      }
    }

    function step(dir) {
      if (!slideStep(dir)) postStep(dir);
    }

    function fill(idx) {
      var post = posts[idx];
      if (!post) return;
      curPost = idx;
      prevBtn.disabled = idx === 0;
      nextBtn.disabled = idx === posts.length - 1;

      var kids = post.children && post.children.data;
      var items =
        post.media_type === 'CAROUSEL_ALBUM' && kids && kids.length
          ? kids
          : [
              {
                media_type: post.media_type,
                media_url: post.media_url,
                thumbnail_url: post.thumbnail_url,
                image_small: post.image_small,
                image_large: post.image_large,
              },
            ];
      showSlide(items, 0);

      captionEl.innerHTML = igCaption(post.caption);
      var stats = '';
      if (post.like_count != null && post.like_count !== '') {
        stats += '<span class="tb-instagram-modal__stat" title="' + igEsc(L.likes) + '">' + IG_HEART_SVG + '<span class="visually-hidden">' + igEsc(L.likes) + ': </span>' + igEsc(igNum(Number(post.like_count))) + '</span>';
      }
      if (post.comments_count != null && post.comments_count !== '') {
        stats += '<span class="tb-instagram-modal__stat" title="' + igEsc(L.comments) + '">' + IG_COMMENT_SVG + '<span class="visually-hidden">' + igEsc(L.comments) + ': </span>' + igEsc(igNum(Number(post.comments_count))) + '</span>';
      }
      statsEl.innerHTML = stats;
      ctaEl.href = igUrl(post.permalink) || profileUrl || 'https://www.instagram.com/';
    }

    function open(idx, trigger) {
      if (clearTimer) {
        clearTimeout(clearTimer);
        clearTimer = null;
      }
      if (igActive && igActive !== controller) igActive.close(true);
      lastFocus = trigger || document.activeElement;
      fill(idx);

      lockPageScroll();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      igActive = controller;

      var closeBtns = modal.querySelectorAll('.tb-instagram-modal__close');
      for (var i = 0; i < closeBtns.length; i++) {
        if (igVisible(closeBtns[i])) {
          closeBtns[i].focus();
          break;
        }
      }
    }

    function close(instant) {
      if (!modal.classList.contains('is-open')) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockPageScroll();
      var v = mediaBox.querySelector('video');
      if (v) v.pause();
      slideToken++;
      if (igActive === controller) igActive = null;
      var clear = function () {
        mediaBox.innerHTML = '';
        unlockBox();
        curSlides = [];
        curSlide = 0;
      };
      if (instant === true) clear();
      else clearTimer = setTimeout(clear, 300);
      if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
        lastFocus.focus();
      }
      lastFocus = null;
    }

    var controller = { modal: modal, close: close, step: step };

    if (modal && mediaBox) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-tb-ig-close]')) {
          close();
          return;
        }
        if (e.target.closest('[data-tb-ig-prev]')) {
          postStep(-1);
          return;
        }
        if (e.target.closest('[data-tb-ig-next]')) {
          postStep(1);
          return;
        }
        var s = e.target.closest('[data-tb-ig-slide]');
        if (s) {
          e.stopPropagation();
          showSlide(curSlides, parseInt(s.getAttribute('data-tb-ig-slide'), 10));
        }
      });

      /* Swipe: nejdřív v albu, na jeho kraji na další příspěvek. */
      var touchX = 0;
      var swiping = false;
      mediaBox.addEventListener(
        'touchstart',
        function (e) {
          touchX = e.touches[0].clientX;
          swiping = false;
        },
        { passive: true }
      );
      mediaBox.addEventListener(
        'touchmove',
        function (e) {
          if (Math.abs(e.touches[0].clientX - touchX) > 10) swiping = true;
        },
        { passive: true }
      );
      mediaBox.addEventListener('touchend', function (e) {
        if (!swiping) return;
        var diff = touchX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 50) return;
        step(diff > 0 ? 1 : -1);
      });
    }

    /* ── Načtení feedu ── */
    function load() {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl
        ? setTimeout(function () {
            ctrl.abort();
          }, IG_FEED_TIMEOUT_MS)
        : null;
      fetch(feedUrl, { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (timer) clearTimeout(timer);
          var list = data && data.ok !== false && Array.isArray(data.data) ? data.data : [];
          posts = list
            .filter(function (p) {
              return p && igTileSrc(p);
            })
            .slice(0, postCount);
          if (!posts.length) {
            hide('prázdný feed');
            return;
          }
          render();
        })
        .catch(function (err) {
          if (timer) clearTimeout(timer);
          hide((err && err.name === 'AbortError' ? 'timeout' : err && err.message) || 'chyba');
        });
    }

    /* Feed se stahuje, až když se sekce blíží k viewportu (homepage je dlouhá). */
    if (!designMode && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) {
            io.disconnect();
            load();
          }
        },
        { rootMargin: '600px 0px' }
      );
      io.observe(el);
    } else {
      load();
    }
  }

  function initInstagram(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sections = root.querySelectorAll('[data-tb-instagram]');
    if (!sections.length) return;
    igBindGlobal();
    Array.prototype.forEach.call(sections, igSetup);
  }

  /* ────────────────────────────────────────────────────────────────────
     Odmítnutí dotazníku Heureka Ověřeno zákazníky (snippet tb-heureka-consent).
     Custom element místo init funkce: cart drawer se překresluje přes innerHTML
     a nově vložený <tb-heureka-consent> se po customElements.define upgraduje sám.

     Checkbox je zároveň pole košíkového formuláře (form="cart" / "CartDrawer-Form"),
     takže klasický checkout hodnotu odešle sám. Tady se změna navíc posílá rovnou
     do /cart/update kvůli rychlým platebním tlačítkům, která formulář neodesílají.
     Kontrakt s hubem: zaškrtnuto = "1", odškrtnuto = "". Chyba se tiše spolkne.

     Na /cart je políčko dvakrát (stránka + skrytý drawer), proto se po změně
     srovnají všechny instance se stejným atributem.
     ──────────────────────────────────────────────────────────────────── */
  var heurekaQueue = Promise.resolve();

  function heurekaCartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) return window.routes.cart_update_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/update.js';
  }

  function heurekaSendAttribute(name, value) {
    var attributes = {};
    attributes[name] = value;
    var config =
      typeof window.fetchConfig === 'function'
        ? window.fetchConfig('json')
        : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          };
    config.body = JSON.stringify({ attributes: attributes });
    /* Řetězení drží pořadí: rychlé zaškrtnutí a odškrtnutí nesmí dorazit obráceně. */
    heurekaQueue = heurekaQueue
      .then(function () {
        return fetch(heurekaCartUpdateUrl(), config);
      })
      .catch(function () {
        /* Tichá chyba, při klasickém checkoutu hodnotu odešle formulář košíku. */
      });
    return heurekaQueue;
  }

  function defineHeurekaConsent() {
    if (!window.customElements || window.customElements.get('tb-heureka-consent')) return;

    class TbHeurekaConsent extends HTMLElement {
      connectedCallback() {
        /* connectedCallback běží i při přesunu v DOM, listener jen jednou. */
        if (this.dataset.tbInit) return;
        this.dataset.tbInit = '1';
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        var target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'checkbox') return;
        var name = this.dataset.attribute || 'heureka_optout';
        var checked = target.checked;

        document.querySelectorAll('tb-heureka-consent').forEach(function (el) {
          if ((el.dataset.attribute || 'heureka_optout') !== name) return;
          var box = el.querySelector('input[type="checkbox"]');
          if (box && box !== target) box.checked = checked;
        });

        heurekaSendAttribute(name, checked ? '1' : '');
      }
    }

    window.customElements.define('tb-heureka-consent', TbHeurekaConsent);
  }

  defineHeurekaConsent();

  /* ──────────────────────────────────────────────────────────────────── */

  /* ────────────────────────────────────────────────────────────────────
     Hover obrázek na kartách produktů (4P, 6P).
     Druhý obrázek má jen data-tb-hover-src, stáhne se při prvním najetí
     myší nebo fokusu. Po načtení dostane karta is-hover-ready a CSS obrázky
     prolne. Delegovaně na documentu, takže nepotřebuje init ani re-init.
     ──────────────────────────────────────────────────────────────────── */
  function loadCardHover(card) {
    if (!card || card.dataset.tbHoverLoading) return;
    var img = card.querySelector('img[data-tb-hover-src]');
    if (!img) return;
    card.dataset.tbHoverLoading = '1';
    img.addEventListener(
      'load',
      function () {
        card.classList.add('is-hover-ready');
      },
      { once: true }
    );
    if (img.dataset.tbHoverSrcset) img.srcset = img.dataset.tbHoverSrcset;
    img.src = img.dataset.tbHoverSrc;
  }

  function onCardHoverIntent(event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    var card = event.target.closest && event.target.closest('[data-tb-card-hover]');
    if (card) loadCardHover(card);
  }

  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('pointerover', onCardHoverIntent, { passive: true });
    document.addEventListener('focusin', onCardHoverIntent);
  }

  /* ────────────────────────────────────────────────────────────────────
     Kopírování textu tlačítkem (patička: telefon a e-mail).
     <button data-tb-copy="text" data-tb-copied="Zkopírováno">. Delegovaně na
     documentu, bez initu. Po zkopírování dostane tlačítko na chvíli is-copied
     (ikona fajfky) a čtečka oznámí hlášku přes živý region.
     ──────────────────────────────────────────────────────────────────── */
  var copyLive = null;

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {}
      ta.remove();
      if (ok) resolve();
      else reject(new Error('copy'));
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-tb-copy]');
    if (!btn) return;
    event.preventDefault();
    copyText(btn.getAttribute('data-tb-copy') || '').then(function () {
      var label = btn.getAttribute('aria-label') || '';
      var done = btn.getAttribute('data-tb-copied') || '';
      btn.classList.add('is-copied');
      if (done) btn.setAttribute('aria-label', done);
      if (!copyLive) {
        copyLive = document.createElement('span');
        copyLive.className = 'visually-hidden';
        copyLive.setAttribute('aria-live', 'polite');
        document.body.appendChild(copyLive);
      }
      copyLive.textContent = '';
      setTimeout(function () {
        copyLive.textContent = done;
      }, 50);
      clearTimeout(btn._tbCopyTimer);
      btn._tbCopyTimer = setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.setAttribute('aria-label', label);
      }, 1800);
    }, function () {});
  });

  /* ────────────────────────────────────────────────────────────────────
     Hero s více produkty (sections/tb-hero-multiproduct.liquid), port
     HeroMultiproductImage z therabody.eu. Slidy se posouvají scrollLeft na <ul>,
     segment progress se plní CSS animací a timeout přepne na další slide.
     Náhled v rohu přepíná na další, tlačítko vpravo nahoře pauzuje.
     Po překreslení sekce v Theme Editoru zůstane starý timeout, ale zastaví se
     na isConnected.
     ──────────────────────────────────────────────────────────────────── */
  function hmpSetup(el) {
    if (el.hasAttribute('data-tb-init')) return;
    el.setAttribute('data-tb-init', '');
    var list = el.querySelector('.tb-hmp__list');
    var slides = el.querySelectorAll('.tb-hmp__slide');
    var segmentsWrap = el.querySelector('.tb-hmp__segments');
    var segments = el.querySelectorAll('.tb-hmp__segment');
    var toggle = el.querySelector('[data-tb-hmp-toggle]');
    if (!list || slides.length < 2 || !segmentsWrap) return;

    var duration = parseFloat(el.getAttribute('data-duration')) || 6;
    var active = 0;
    var timer = null;
    var playing = true;

    function schedule(seconds) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!el.isConnected) return;
        go(active === slides.length - 1 ? 0 : active + 1);
      }, seconds * 1000);
    }

    function go(index) {
      segments[active].classList.remove('is-active');
      active = index;
      segments[active].classList.add('is-active');
      list.scrollLeft = active * list.clientWidth;
      Array.prototype.forEach.call(slides, function (slide, i) {
        var hidden = i !== active;
        if (hidden) slide.setAttribute('aria-hidden', 'true');
        else slide.removeAttribute('aria-hidden');
        slide.querySelectorAll('a, button').forEach(function (node) {
          if (hidden) node.setAttribute('tabindex', '-1');
          else node.removeAttribute('tabindex');
        });
      });
      if (playing) schedule(duration);
    }

    el.querySelectorAll('[data-tb-hmp-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(active === slides.length - 1 ? 0 : active + 1);
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        playing = !playing;
        toggle.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-label', toggle.getAttribute(playing ? 'data-label-pause' : 'data-label-play') || '');
        segmentsWrap.classList.toggle('is-paused', !playing);
        if (playing) {
          /* zbytek doby podle toho, kam animace progressu došla */
          var progress = segments[active].querySelector('.tb-hmp__progress');
          var anim = progress && progress.getAnimations ? progress.getAnimations()[0] : null;
          var elapsed = anim && anim.currentTime ? anim.currentTime / 1000 : 0;
          schedule(Math.max(duration - elapsed, 0.1));
        } else {
          clearTimeout(timer);
        }
      });
    }

    /* po změně šířky držet aktivní slide bez animace */
    window.addEventListener('resize', function () {
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = active * list.clientWidth;
      list.style.scrollBehavior = '';
    });

    schedule(duration);
  }

  function initHeroMultiproduct(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-tb-hmp]'), hmpSetup);
  }

  function initAll(scope) {
    var root = scope || document;
    initHeroMultiproduct(root);
    initDragScrollAll(root);
    initTabs(root);
    initSizeChart();
    initResultsSlider();
    initBeforeAfter(root);
    initDataRequestForm();
    initContactForm(root);
    initPriceInfo(root);
    initPriceVariantSync();
    initDeliveryInfo();
    initCardAction();
    initProductQuestion(root);
    initInstagram(root);
    initStickyAtc();
    initRestock();
    initWithdrawal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme Editor překresluje jednotlivé sekce, inline skript by se spustil sám. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
    /* Prvky přesouvané pod <body> a delegované listenery jsou mimo section scope. */
    initSizeChart();
    initStickyAtc();
    initRestock();
  });

  /* Drag-scroll je vázaný na breakpoint, po změně šířky může přibýt cíl. */
  window.addEventListener('resize', function () {
    initDragScrollAll(document);
  });
})();
